import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class OneColFeature {
    constructor() {
        const self = this;

        window.addEventListener('load', () => {
            self.selectors = {
                root: '[data-pinned-img]'
            };

            self.body = document.body;
            self.rootElem = document.querySelector(this.selectors.root);

            if (!self.rootElem) return;

            self.init();
        });
    }

    resizeWidth() {
        if (window.innerWidth < 768) {
            return `${window.innerWidth - 80}px`;
        } else if (window.innerWidth < 992) {
            return '475px';
        }
        return '781px';
    }

    resizeHeight() {
        if (window.innerWidth < 768) {
            return `${(window.innerWidth - 50) * 0.46}px`;
        } else if (window.innerWidth < 992) {
            return '235px';
        }
        return '360px';
    }

    resizeHeightContainer() {
        const windowWidth = window.innerWidth;

        let responsiveGsapData = {
            start: 'top 200px',
            end: '+=100'
        };

        switch (windowWidth) {
            case windowWidth < 768:
                responsiveGsapData = {
                    start: 'top 50px',
                    end: '+=100'
                };
                break;
            case windowWidth <= 992 && windowWidth >= 768:
                responsiveGsapData = {
                    start: 'top 10px',
                    end: '+=150'
                };
                break;
            case windowWidth > 992:
                responsiveGsapData = {
                    start: 'top 50px',
                    end: 'top -100%'
                };
                break;
            default:
                responsiveGsapData = {
                    start: 'top 50px',
                    end: 'top -100%'
                };
                break;

        }
        return responsiveGsapData;
    }

    resizeBorderRadius() {
        if (window.innerWidth < 768) {
            return '20px';
        }
        return '40px';
    }

    setImgBorderMobile() {
        if (window.innerWidth < 768) {
            const imgBorder = document.querySelector('.resize-border');
            const phone = document.querySelector('.resize-phone');
            imgBorder.style.width = `${window.innerWidth - 40}px`;
            imgBorder.style.height = `${(window.innerWidth - 40) * 0.46}px`;
            phone.style.width = `${window.innerWidth - 45}px`;
            phone.style.height = `${(window.innerWidth - 47) * 0.46}px`;
        }
    }

    resizeImage() {
        gsap.to('.resize-img', {
            duration: 0.5,
            width: this.resizeWidth(),
            height: this.resizeHeight(),
            borderRadius: this.resizeBorderRadius(),
            ease: 'none',
            scrollTrigger: {
                trigger: '.resize-img-contaiener',
                start: this.resizeHeightContainer().start,
                end: this.resizeHeightContainer().end,
                scrub: true,
                pin: true
            }
        });
    }

    init() {
        this.resizeImage();
        this.setImgBorderMobile();
    }
}
